<template>
  <div class="_make-article">
    
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">เริ่มต้นใช้งาน API</h1>
    </header>
    <div class="MarkdownContent" style="width: 80%;">
      <p class="preindent">เริ่มต้นการใช้งาน จะต้องลงทะเบียนสร้างบัญชีกับทาง One Platform เสียก่อน หลังจากนั้นเข้าสู่ระบบและกดเปิดใช้งาน Bot API เพื่อเปิดใช้ API กับทาง OneChat</p> 
    </div>
    <header class="EndpointHeader">
      <h2 class="EndpointTitle">การเปิดใช้งาน Bot API ผ่านทางเว็บไซต์</h2>
    </header>
    <div class="MarkdownContent">
      <p class="preindent hidden-sm-and-down" >ลงชื่อเข้าใช้ระบบ หลังจากนั้นเลือก<a @click="routeinfo('/develop/information_dev')">ดูข้อมูลผู้พัฒนา</a> เลื่อนลงไปยังส่วนของข้อมูลการใช้ API และกดเปิดใช้งาน API</p>
      <p class="preindent hidden-md-and-up" >ลงชื่อเข้าใช้ระบบ หลังจากนั้นเลือก<a @click="routeinfo('/mobile/develop/profile')">ดูข้อมูลผู้พัฒนา</a> เลื่อนลงไปยังส่วนของข้อมูลการใช้ API และกดเปิดใช้งาน API</p>
      <h3>ภาพตัวอย่างหน้าการเปิดใช้งาน Bot API</h3>
      <img src="../../assets/image/openAPI2.png" style="width: 50vw;" class="hidden-sm-and-down">
      <img src="../../assets/image/openAPI3.png" style="width: 90vw;" class="hidden-md-and-up">
      <p class="preindent">หลังจากนั้นจะได้ข้อมูลสำหรับใช้ในการส่ง API</p>
    </div>

  </div>
</section>

</div>

      </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
  }),
  created () {
  },
  methods: {
    routeinfo (page) {
      this.$router.push(page)
    }
  }
}
</script>

<style type="text/css" scoped>
.preindent {
  text-indent: 2em;
  text-align: justify;
}

._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 90vw;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
    /*cursor: pointer;*/
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


/*.divbutton {
    height: 30px;
    background: #000;
}*/

.requestfile {
    display: none !important;
}

.codecolor:hover .requestfile {
    display: block !important;
}

.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.responsefile{
    display: none !important;
}

.codecolor:hover .responsefile {
    display: block !important;
}
#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/startchatapi.vue